import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { ConfirmModal } from "../ConfirmModal/ConfirmModal";
import { ButtonInfo } from "../Button/Info";
import { ButtonBack } from "../Button/Back";
import SelectSearch from "../UI/SelectSearch/SelectSearch"
import {getMessagemErro} from "../../utils/erro";
import api from "../../services/api";
import './Application.css';

const mapDispatchToProps = { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }
const LIMITE_EXIBICAO_FINALIDADE = 500;

export const ApplicationAccess =

withRouter(

// redux
connect(
	null, 
	(mapDispatchToProps)
)(
	class extends Component {

		constructor(props){
			super(props);
			this.state = {
				aplicacaoConsumidora: {
					id: undefined,
					nome: "",
				},
				adesoes: [],
				adesoesOrgao: [],
				adesao: {
					idAdesao: '',
					finalidade: '',
				},
				alteracao: false,
				botoesHabilitados: true,
				exibeModalExcluir: false,
			};
			this.handleInputChange = this.handleInputChange.bind(this);
			this.handleAdesaoChange = this.handleAdesaoChange.bind(this);
			this.carregarAdesoesConsumidora = this.carregarAdesoesConsumidora.bind(this);
			this.carregarAdesoesOrgao = this.carregarAdesoesOrgao.bind(this);
			this.salvar = this.salvar.bind(this);
			this.editarAdesao = this.editarAdesao.bind(this);
			this.alterarAdesao = this.alterarAdesao.bind(this);
			this.excluirAdesao = this.excluirAdesao.bind(this);
			this.limpar = this.limpar.bind(this);
			this.confirmarExclusao = this.confirmarExclusao.bind(this);
			this.fecharModal = this.fecharModal.bind(this);
			this.toggleFinalidade = this.toggleFinalidade.bind(this);
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
						<Message />
						<Loading />
						
						<div  style={{margin: "10px"}}>
							<h1>Cadastro de Aplicação - Adesões às API'S</h1>
						</div>

					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();
			const id = this.props.match.params.id;
			if(id){
				api.get('/api/aplicacao-consumidora/' + id)
					.then(response => { 
						const aplicacaoConsumidora = response.data;
						this.setState(
							{
								aplicacaoConsumidora,
							}) 
						this.carregarAdesoesOrgao(aplicacaoConsumidora.orgao);
					})
					.catch(erro => {
						console.log("Não foi possível recuperar a aplicação consumidora " + erro)
						this.props.exibeMensagemErro("Erro durante o carregamento da página")
					});
			}

			this.carregarAdesoesConsumidora();
			
		}

		carregarAdesoesOrgao(idOrgao) {
			api.get(`/api/orgao/${idOrgao}/adesoes`)
				.then(response => { 
					const adesoesOrgao = response.data;
					this.setState(
						{
							adesoesOrgao,
						}) 
				})
				.catch(erro => {
					console.log("Não foi possível recuperar as adesões do órgão " + erro)
					this.props.exibeMensagemErro("Erro durante o carregamento da página")
				});
		}

		carregarAdesoesConsumidora(){
			const id = this.props.match.params.id;
			if(id){
				api.get(`/api/aplicacao-consumidora/${id}/adesoes`)
					.then(response => { 
						let adesoes = response.data;
						adesoes = adesoes.map((adesao) => {
							const finalidade = adesao.finalidade;
							const exibeExpandirComrimir = finalidade.length > LIMITE_EXIBICAO_FINALIDADE;
							adesao['exibeExpandirComrimir'] = exibeExpandirComrimir;
							adesao['mostraFinalidadeResumida'] = exibeExpandirComrimir;
							return adesao;
						})

						this.setState(
							{
								adesoes,
							}) 
					})
					.catch(erro => {
						console.log("Não foi possível recuperar as adesões da aplicação consumidora " + erro)
						this.props.exibeMensagemErro("Erro durante o carregamento da página")
					});
			}
		}

		renderForm() {
			const { adesoes } = this.state;
			return(
				<div className="container-fluid">
					<ConfirmModal titulo="Confirmação" 
						visible={this.state.exibeModalExcluir}
						handleOk={() => this.excluirAdesao()}
						handleCancel={() => this.fecharModal()}
						message="Deseja realmente remover a adesão? As chaves geradas para essa aplicação acessar essa API serão desabilitadas."/>

					<div className="br-form">

					<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Aplicação:</label>
										{this.state.aplicacaoConsumidora.nome}
									</div>
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>API:</label>
										{this.state.adesoesOrgao.length > 0 && //todo vazio limpar
											<SelectSearch
												id="idAdesao"
												name="idAdesao"
												options={this.state.adesoesOrgao.map(adesao => ({ value: adesao.id, label: adesao.nomeFornecedora }))}
												placeholder="Selecione uma opção"
												onChange={this.handleAdesaoChange}
												value={this.state.adesao.idAdesao}
											/>
										}
										{this.state.adesoesOrgao.length === 0 && 'O órgão não possui adesões a APIs.'}
									</div>
								</div>
							</div>
						</div>

						{this.state.adesao.idAdesao !== '' &&
							<div className="row">
								<div className="col-md">
									<div className="field">
										<div className="input">
											<div className="row">
												<div className="col-md">
													<label>Finalidade:</label>
													&nbsp;
													<ButtonInfo title="Conforme o artigo 6º da Lei nº 13.709 (Lei Geral de Proteção de Dados – LGPD), o órgão público consumidor de dados pessoais deve informar a finalidade específica à qual se destina o uso daquela informação.  A finalidade aqui declarada poderá ser informada ao cidadão titular do dado consultado, portanto, deve ser descrita com clareza e objetividade"/>
												</div>
											</div>
											<textarea name="finalidade" value={this.state.adesao.finalidade} onChange={this.handleInputChange} maxLength={3000} style={{height:"90px"}} />
										</div>
									</div>
								</div>
							</div>
						}

						<div className="actions-button">
							<div className="actions justify-content-start">
								{ this.state.alteracao === false &&
									<button type="button" className="button is-primary" onClick={this.salvar} disabled={this.state.botoesHabilitados === false}>Incluir</button>
								}

								{ this.state.alteracao === true &&
									<button type="button" className="button is-primary" onClick={this.salvar} disabled={this.state.botoesHabilitados === false}>Alterar</button>
								}

								<button type="button" className="button is-secondary" onClick={this.limpar} disabled={this.state.botoesHabilitados === false}>Limpar</button>
								
								<ButtonBack disabled={!this.state.botoesHabilitados} />
							</div>
						</div>
						
						<fieldset>
							<legend>Adesões cadastradas</legend>
							{(adesoes && adesoes.length > 0) &&	
								<div className="br-table">						
									<div className="table">
										<table>
											<thead>
												<tr>
												<th scope="col">API</th>
												<th scope="col">Finalidade</th>
												<th className="text-center" scope="col">Ações</th>
												</tr>
											</thead>
											
											<tbody>
												{ adesoes.map((adesao, index) =>
														<tr key={index} >
															<td>{adesao.nomeFornecedora}</td>
															<td style={{width: "45%"}}>
																{this.getFinalidade(adesao)}
															</td>
															<td className="text-center">
																<div className="actions">
																	<button type="button" onClick={() => this.confirmarExclusao(adesao)} disabled={this.state.botoesHabilitados === false} title="Excluir Adesão">
																		<span className="sr-only">Excluir</span>
																		<i className="fas fa-trash"></i>
																	</button>

																	<button type="button" onClick={() => this.editarAdesao(adesao)} disabled={this.state.botoesHabilitados === false} title="Editar Adesão">
																		<span className="sr-only">Editar</span>
																		<i className="fas fa-edit"></i>
																	</button>

																	{adesao.exibeExpandirComrimir === true &&
																		<button type="button" onClick={() => this.toggleFinalidade(adesao)} disabled={this.state.botoesHabilitados === false} title={adesao.mostraFinalidadeResumida ? "Expandir Finalidade" : "Comprimir Finalidade"}>
																			<span className="sr-only">Expandir/Comprimir Finalidade</span>
																			<i className={adesao.mostraFinalidadeResumida ? "fas fa-plus-square" : "fas fa-minus-square"}></i>
																		</button>
																	}
																</div>
															</td>
														</tr>
													)}
											</tbody>
										</table>
									</div>
								</div>
							}

							{(! adesoes || adesoes.length === 0) &&
								<div>
									Nenhuma adesão cadastrada para a aplicação.
								</div>
							}
						</fieldset>
					</div>

				</div>
			);
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;

			const adesao = this.state.adesao;
			adesao[nome] = valor;
			this.setState({ adesao });
		}

		handleAdesaoChange(evento){
			this.props.limpaMensagem();
			const idAdesao =  evento.target.value;
			const adesaoCadastradaConsumidora = this.getAdesaoCadastradaAplicacao(idAdesao);

			if (adesaoCadastradaConsumidora){
				this.editarAdesao(adesaoCadastradaConsumidora);
			}else{
				const adesao = {idAdesao, finalidade: ''}

				this.setState({
					adesao,
					alteracao: false,
				});
			}
		}

		getAdesaoCadastradaAplicacao(idAdesao){
			for(var adesao of this.state.adesoes){
				if(adesao['idAdesao'] === parseInt(idAdesao)){
					return adesao;
				}
			}
			return;
		}

		salvar(e){
			this.props.limpaMensagem();

			try{
				this.validaFormulario();
			}catch(erroValidacao){
				e.preventDefault();
				return;
			}

			this.setState({botoesHabilitados:false});
			const adesao = this.state.adesao;
			const method = this.state.alteracao === true ? 'put' : 'post';
			let url = `/api/aplicacao-consumidora/${this.state.aplicacaoConsumidora.id}/adesao`;

			const options = {
				method,
				url,
				"data" : adesao,
			}
			this.props.mostraAguardando(); 

			api(options)
				.then(response => {
					const mensagem = `Adesão ${this.state.alteracao === true ? 'alterada' : 'incluída'} com sucesso!`;
					this.carregarAdesoesConsumidora();
					this.setState({
						adesao: {idAdesao: '', finalidade: ''},
						alteracao : false
					})
					this.props.exibeMensagemSucesso(mensagem);
				})
				.catch(erro => {
					const mensagemInicial = `Não foi possível ${this.state.alteracao === true ? 'alterar' : 'incluir'} a adesão.`;
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then (() =>{
					this.props.escondeAguardando();
					this.setState({botoesHabilitados:true});
				});   

		}

		alterarAdesao(){
			this.salvar(this.state.e);
		}

		editarAdesao(adesao){
			this.props.limpaMensagem();
			this.setState({adesao: {...adesao}, alteracao: true});
			window.scrollTo(0, 0);
		}

		confirmarExclusao(adesao) {
			this.setState(
				{
					exibeModalExcluir: true,
					adesaoAlvo: adesao,
				}
			);
		}

		getFinalidade(adesao) {
			return adesao.mostraFinalidadeResumida ? adesao.finalidade.substring(0, LIMITE_EXIBICAO_FINALIDADE) + '...' : adesao.finalidade;
		}

		toggleFinalidade(adesao) {
			const adesoes = this.state.adesoes;
			this.getAdesaoCadastradaAplicacao(adesao.idAdesao)['mostraFinalidadeResumida'] = ! adesao.mostraFinalidadeResumida;
			this.setState({adesoes});
		}

		fecharModal () {
			this.setState(
				{
					exibeModalExcluir:false,
				}
			);
		}

		excluirAdesao(){
			this.props.limpaMensagem();
			const adesao = this.state.adesaoAlvo;
			let url = `/api/aplicacao-consumidora/${adesao.idConsumidora}/adesao/${adesao.idAdesao}`;
			const options = {
				method: 'delete',
				url,
			}
			this.props.mostraAguardando(); 
			this.setState({botoesHabilitados:false});

			api(options)
				.then(response => {
					const mensagem = `Adesão excluída com sucesso!`;
					this.carregarAdesoesConsumidora();
					this.props.exibeMensagemSucesso(mensagem);
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível excluir a adesão.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then (() =>{
					this.props.escondeAguardando();
					this.setState({botoesHabilitados:true});
				});   
			
			this.fecharModal();
		}

		limpar(){
			this.props.limpaMensagem();
			this.setState({
				adesao: {idAdesao: '', finalidade: ''},
				alteracao : false,
			})
		}

		validaFormulario(){
			let mensagens = [];
			const adesao = this.state.adesao;
			if(adesao.idAdesao === "" ){
				mensagens.push({mensagem: "API é obrigatório."})
			}

			if(!adesao.finalidade || adesao.finalidade.trim().length === 0 ){
				mensagens.push({mensagem: "Finalidade é obrigatória."})
			}

			if(mensagens.length > 0){
				this.props.exibeMensagemErro("Não foi possível realizar a operação porque há inconsistências nos campos informados:", mensagens)
				throw new Error("Formulário não preenchido corretamente.");
			}
		}

	}

) // redux
); // router